import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import type { Comic } from "@/mocks/comics";
import { filterComics } from "@/lib/comics";

const TABS = [
  { key: "latest", label: "最新更新" },
  { key: "hot", label: "人气最高" },
  { key: "score", label: "口碑评分" },
];

export default function LatestGrid({ comics }: { comics: Comic[] }) {
  const [tab, setTab] = useState("latest");
  const [showAll, setShowAll] = useState(false);

  const sorted = useMemo(() => {
    const list = filterComics(comics, { sort: tab });
    return showAll ? list : list.slice(0, 12);
  }, [comics, tab, showAll]);

  return (
    <section aria-labelledby="latest-title" className="w-full px-4 md:px-6">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-5">
        <div>
          <h2 id="latest-title" className="font-heading text-xl md:text-2xl font-semibold text-foreground-50">
            最新更新列表
          </h2>
          <p className="mt-1.5 text-xs md:text-sm text-foreground-400">
            每日汇总新上线与刚更新的作品，点击卡片查看详情、章节与资源说明。
          </p>
        </div>
        <div className="flex items-center gap-1 px-1 py-1 rounded-full border hairline bg-background-900/70 w-fit">
          {TABS.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={`h-8 px-3.5 rounded-full text-xs transition-colors cursor-pointer whitespace-nowrap ${
                tab === item.key ? "bg-accent-500 text-background-950 font-medium" : "text-foreground-300 hover:text-foreground-50"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
        {sorted.map((comic, i) => (
          <div key={comic.id} className="animate-fade-up" style={{ animationDelay: `${(i % 8) * 40}ms` }}>
            <ComicCard comic={comic} />
          </div>
        ))}
      </div>

      <div className="mt-6 flex items-center justify-center gap-3">
        {!showAll && comics.length > 12 && (
          <button
            type="button"
            onClick={() => setShowAll(true)}
            className="h-10 px-5 rounded-md border hairline bg-background-900/70 text-sm text-foreground-200 hover:border-accent-500/50 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            展开全部 {comics.length} 部作品
          </button>
        )}
        <Link
          to="/category/hot-blood"
          className="h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm flex items-center gap-1.5 hover:bg-primary-400 transition-colors whitespace-nowrap"
        >
          进入分类页筛选
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}